import "./Footer.css";
import Container from "react-bootstrap/esm/Container";
import Row from "react-bootstrap/esm/Row";
import Col from "react-bootstrap/esm/Col";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faLocationDot,
  faCopyright,
} from "@fortawesome/free-solid-svg-icons";

const Footer = () => {
  return (
    <>
      <Container fluid className="m-0 p-0 footer_root">
        <Container className="footer_wrapper">
          <Row className="footer_wrapper_row">
            <Col lg={5} className="logo_footer">
              <div>
                <img
                  src="assets/images/Logo.png"
                  alt="orange_pattern"
                  className="footer_logo"
                />
              </div>

              <p>
                We offer customers a wide range of genuine OEM and aftermarket
                spares for all vehicle types. With direct procurement spares
                listing policy we ensure lowest rates with best in class
                services.
              </p>
            </Col>
            <Col lg={2} className="footer_links">
              <h5>Quick Links</h5>
              <ul>
                <li>
                  <a href="/#home">Home</a>
                </li>
                <li>
                  <a href="/#about">About us</a>
                </li>
                <li>
                  <a href="/#products">Products</a>
                </li>
                <li>
                  <a href="/#branches">Branches</a>
                </li>
                <li>
                  <a href="/#contact">Contact Us</a>
                </li>
              </ul>
            </Col>
            <Col lg={5} className="footer_address">
              <h5 className="main_title">Address</h5>
              <div className="footer_address_icon_wrapper">
                <div className="footer_address_icon_container mt-lg-5">
                  <div>
                    <FontAwesomeIcon icon={faLocationDot} />
                  </div>
                  <div>
                    <h4 className="title">Our location</h4>
                    <p>
                      Pradeep Automotive Ltd. Phoenix Bldg. B,Shop No. 8, Benham
                      Hall Lane. S.V.P Road. Mumbai(400004)
                    </p>
                  </div>
                </div>
                <div className="footer_address_icon_container">
                  <div>
                    <FontAwesomeIcon icon={faEnvelope} />
                  </div>
                  <div>
                    <h4 className="title">Quick Contact</h4>

                    <p style={{ marginBottom: 0 }}>
                      Email : info@pradeepautomotive.com
                      <br />
                      Phone : 022 23808403
                    </p>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
        <div className="footer_bottom ">
          <ul>
            <li>Terms & conditions</li>
            <li>Privacy Policy</li>
          </ul>
          <div>
            {/* <p>CopyRight 2023</p> */}
            <FontAwesomeIcon icon={faCopyright} />
            <p>Pradeep Automotives.</p>
            <p>All Rights Reserved</p>
          </div>
        </div>
      </Container>
    </>
  );
};

export default Footer;
